export const initFixedBackground = () => {
  // Select relevant DOM elements
  const fixedBackground = document.querySelector(
    '.section--homepage-fixed-background',
  );
  const heroContent = document.querySelector(
    '.section--homepage-hero .hero-content',
  );

  const heroContentBG = document.querySelector(
    '.section--homepage-hero .hero-content-background',
  );
  const homepageNav = document.querySelector('.homepage-nav');
  const windowHeight = window.innerHeight;

  // Check if required elements are present
  if (!fixedBackground || !heroContent || !homepageNav) {
    return; // No action needed if the elements are not present
  }

  const onScroll = () => {
    const scroll = window.scrollY || document.documentElement.scrollTop;

    // Calculate the percentage scrolled relative to one viewport height
    const scrollPercentage = Math.min(1, scroll / windowHeight);

    // Update styles based on scroll position and visibility conditions
    heroContent.style.opacity = 1 - scrollPercentage * 2.5;
    heroContentBG.style.opacity = scrollPercentage / 1.07;

    // Add 'active' class to homepageNav after one viewport height is scrolled
    if (scrollPercentage >= 0.95) {
      homepageNav.classList.add('active');
    } else {
      homepageNav.classList.remove('active');
    }
  };

  // Attach the onScroll function to the scroll event
  window.addEventListener('scroll', onScroll);

  // Initial setup to set the initial state of the effect
  onScroll();
};
